const authDefaultState = {
  uid: "",
  displayName: "",
  email: "",
  photoURL: "",
  error: false,
  errorMessage: "",
}

export default (state = authDefaultState, action) => {
  switch (action.type) {
    case "LOGIN":
      return {
        ...state,
        uid: action.uid,
        displayName: action.displayName,
        email: action.email,
        photoURL: action.photoURL,
        error: false,
        errorMessage: "",
      }
    case "LOGOUT":
      return authDefaultState

    case "AUTH_ERROR":
      return {
        ...state,
        error: action.errorCode,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
